// extracted by mini-css-extract-plugin
export default {"rating":"vz-z","numberOfStars":"wz-z","count":"xz-z","barGraphSpacing":"yz-z","barGraph":"zz-z"};